import script from "./MenuView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuView.vue?vue&type=script&lang=ts&setup=true"

import "./MenuView.vue?vue&type=style&index=0&id=0ade605e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ade605e"]])

export default __exports__